import _slicedToArray from "/var/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import * as React from "react";
export var useContainerRect = function useContainerRect() {
  var _React$useState = React.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      containerRect = _React$useState2[0],
      setContainerRect = _React$useState2[1];

  var containerRef = React.useRef(null);
  var observerRef = React.useRef();
  var setContainerRef = React.useCallback(function (node) {
    containerRef.current = node;

    if (observerRef.current) {
      observerRef.current.disconnect();
      observerRef.current = undefined;
    }

    var updateContainerRect = function updateContainerRect() {
      if (node) {
        var styles = window.getComputedStyle(node);

        var parse = function parse(value) {
          return parseFloat(value) || 0;
        };

        setContainerRect({
          width: Math.round(node.clientWidth - parse(styles.paddingLeft) - parse(styles.paddingRight)),
          height: Math.round(node.clientHeight - parse(styles.paddingTop) - parse(styles.paddingBottom))
        });
      } else {
        setContainerRect(undefined);
      }
    };

    updateContainerRect();

    if (node && typeof ResizeObserver !== "undefined") {
      observerRef.current = new ResizeObserver(updateContainerRect);
      observerRef.current.observe(node);
    }
  }, []);
  return React.useMemo(function () {
    return {
      setContainerRef: setContainerRef,
      containerRef: containerRef,
      containerRect: containerRect
    };
  }, [setContainerRef, containerRef, containerRect]);
};